<template>
  <nuxt-layout>
    <page-template>
      <div class="container">
        <div class="mx-auto max-w-xl py-8">
          <div class="flex h-40 w-full justify-center pb-4">
            <img loading="lazy" src="/images/mascots/kornelia.png" />
          </div>
          <div class="w-full overflow-hidden rounded-[20px] rounded-tl-[0px] bg-white shadow-sm">
            <div class="mx-auto w-full max-w-[750px] p-6 pb-0 md:max-w-[850px] md:p-10 md:pb-0">
              <div v-if="error.statusCode === 404" class="max-w-xl text-left">
                <h1 class="pb-4 font-headline text-h2">Oj, den sidan hittade vi inte!</h1>
              </div>
              <div v-else class="max-w-xl text-left">
                <h1 class="pb-4 font-headline text-h2">Oj, ett fel har inträffat!</h1>
              </div>
              <div class="text-left font-body text-body font-normal text-black">
                <p>
                  Gå till vår framsida eller prova att söka efter innehållet genom att använda vår
                  sökfunktion längst upp på sidan.
                </p>
                <div class="pt-6 text-left">
                  <div class="w-full">
                    <nuxt-link class="link" to="/">
                      <app-button
                        class="mb-10"
                        variant="purple"
                        size="desktop"
                        arrow-type="double"
                        type="button"
                        >Gå till framsidan</app-button
                      >
                    </nuxt-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div></div>
      </div>
    </page-template>
  </nuxt-layout>
</template>

<script lang="ts">
export default defineNuxtComponent({
  props: {
    error: {
      type: Object,
      default: () => {},
    },
  },
})
</script>
